module.exports = __webpack_public_path__ + "static/media/questions_amber.2d3bb674.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/questions_amber.svg
// module id = 1102
// module chunks = 2